import React, { useState } from "react";
import PropTypes from "prop-types";
import "./style.scss";

import IconTrash from "./img/Trash.svg";
import {Button} from '../Button';

const OPTION_ID = "optionID";
const OPTION_TYPE = "optionTYPE";

export function GelItem(props) {
  const onClick = (event) => {
    event.preventDefault();
    props.setOffset(props.type, props.id, event.clientY);
  };
  const dragStart = (event) => {
    event.dataTransfer.setData(OPTION_ID, props.id);
    event.dataTransfer.setData(OPTION_TYPE, props.type);

    let targetElem = event.currentTarget;
    targetElem.lastX = event.clientX;
    targetElem.lastY = event.clientY;

    props.setCurrentObj(targetElem);
  };

  return (
    <li
      onDragStart={dragStart}
      draggable="true"
      style={{
        width: "calc(100% - 16px)",
        height: "19px",
        margin: "0 8px",
        background: "#0063C3",
        transform: "translateY(" + props.offset + "px)",
        position: "absolute",
        cursor: "move",
        zIndex: 99 - props.id
      }}
    >
      {/*<div className='moveButton' style={{cursor: 'pointer'}} onClick={()=>props.addControlItem(props.id)}></div>
      <img draggable={true} style={{cursor: 'move'}} onDragStart={dragStart} src={Control_1_Thermocycler} />*/}
      <p
        style={{ color: "white", textAlign: "center", margin: 0 }}
        tabIndex={0}
      >
        {/*props.id*/}
      </p>
    </li>
  );
}
GelItem.propTypes = {
  type: PropTypes.string,
  id: PropTypes.string,
  setOffset: PropTypes.function,
  offset: PropTypes.float,
};

export function TrashItem(props) {
  const onClick = (event) => {
    event.preventDefault();
    props.setOffset(props.type, props.id, event.clientY);
  };
  const dragStart = (event) => {
    event.dataTransfer.setData(OPTION_ID, props.id);
    event.dataTransfer.setData(OPTION_TYPE, props.type);

    let targetElem = event.currentTarget;

    props.setCurrentObj(targetElem);
  };

  return (
    <li
      onDragStart={dragStart}
      draggable="true"
      style={{
        width: "calc(100% - 8px)",
        height: "19px",
        background: "#0063C3",
        margin: "8px 4px 0",
        cursor: "move"
      }}
    >
      <p
        style={{ color: "white", textAlign: "center", margin: 0 }}
        tabIndex={0}
      >
        {props.id}
      </p>
    </li>
  );
}
TrashItem.propTypes = {
  type: PropTypes.string,
  id: PropTypes.string,
  currentObj: PropTypes.object,
  setCurrentObj: PropTypes.function,
};

export function GelDragDrop(props) {
  const [currentObj, setCurrentObj] = useState(null);
  const [submitted, setSubmitted] = useState(false);

  const dragOver = (event) => {
    event.preventDefault();
  };

  const getTransform = (elem) => {
    var matrix = getComputedStyle(elem, null).transform;

    var regex = /-?\d*\.{0,1}\d+/g;
    var values = matrix.match(regex);

    var translateX = "";
    var translateY = "";

    if (values != null) {
      translateX = values[4];
      translateY = values[5];
    }

    return {
      translateX: translateX,
      translateY: translateY,
    };
  };

  const dropOption = (event) => {
    event.preventDefault();
    const itemID = parseInt(event.dataTransfer.getData(OPTION_ID));
    const type = event.dataTransfer.getData(OPTION_TYPE);

    // Calculate new position
    var iCurrentY = event.clientY;
    var iCurrentX = event.clientX;

    var transform = getTransform(currentObj);

    var iYPos = parseFloat(transform.translateY);
    var iXPos = parseFloat(transform.translateX);

    var iNewX = (!isNaN(iXPos) ? iXPos : 0) + iCurrentX - currentObj.lastX;
    var iNewY = (!isNaN(iYPos) ? iYPos : 0) + iCurrentY - currentObj.lastY;

    if(iNewY < 0){
      iNewY = -55;
    } else if((iNewY + 19) > height){
      iNewY = height - 19;
    }

    setOffset(type, itemID, iNewY);

    currentObj.lastX = iCurrentX;
    currentObj.lastY = iCurrentY;
  };

  const dropTrash = (event) => {
    event.preventDefault();
    const itemID = parseInt(event.dataTransfer.getData(OPTION_ID));
    const type = event.dataTransfer.getData(OPTION_TYPE);

    setOffset(type, itemID, null);
  };

  const setOffset = (type, itemID, offset) => {
    let newState = {};
    newState[type] = lanes[type];
    newState[type][itemID - 1] = offset;

    setLanes({ ...lanes, ...newState });
  };

  const range = [0, 1000];
  const ticks = [100, 300, 500, 800, 1000];
  const [lanes, setLanes] = useState(props.gelDragDropPrediction);

  const height = 200;

  const getTicks = (ticks) => {
    ticks = ticks
      .sort((a, b) => {
        return a - b;
      })
      .reverse();

    return (
      <ul
        style={{ position: "relative", width: "80px", height: height + "px" }}
      >
        {ticks.map((tick, index) => (
          <li
            style={{
              position: "absolute",
              bottom:
                20 + (height / (range[1] - range[0])) * tick - 20 + "px",
            }}
          >
            {tick + " bp"}
          </li>
        ))}
      </ul>
    );
  };

  const getLadder = (ticks) => {
    ticks = ticks
      .sort((a, b) => {
        return a - b;
      })
      .reverse();

    return (
      <ul
        style={{ position: "relative", height: height, padding: "20px 0" }}
      >
        {ticks.map((tick, index) => (
          <li
            style={{
              position: "absolute",
              bottom:
                20 + (height / (range[1] - range[0])) * tick - 20 + "px",
              width: "calc(100% - 16px)",
              height: "19px",
              margin: "0 8px",
            }}
          >
            <div style={{background: "#003E6B", opacity: "0.5", width: "100%", height: "100%"}}></div>
          </li>
        ))}
      </ul>
    );
  };

  const saveGel = () => {
    setSubmitted(true);
    props.saveGelDragDropPrediction(lanes)
  }

  return (
    <div className={props.className}>
      <p style={{
        margin: "0 0 4px 0",
        fontSize: "14px",
        fontWeight: 600,
        textTransform: "uppercase"
      }}>Prediction Question</p>
      <h5 tabIndex={0}>{props.heading}</h5>
      <p style={{ whiteSpace: "pre-wrap" }} tabIndex={0}>
        {props.text}
      </p>
      <div className="dragdropWrapper" onDragOver={dragOver}>
        <h5 style={{ color: "white" }}>
          Drag the results you predict into each lane.
        </h5>
        <div>
          <ul
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "flex-end",
            }}
          >
            <li style={{ color: "white", height: height + "px" }}>
              {getTicks(ticks)}
            </li>
            {Object.keys(lanes).map((lane, index) => (
              <li
                style={{
                  width:
                    "calc(" +
                    100 / (Object.keys(lanes).length - 1) +
                    "% - " +
                    100 / (Object.keys(lanes).length - 1) +
                    "px)",
                }}
              >
                <p style={{ color: "white", textAlign: "center" }}>{lane}</p>
                <div
                  style={{ height: "19px", background: "#99DFF9", padding: "16px 8px" }}
                  onDrop={dropOption}
                >
                  <div style={{
                    background: "#79C4E0",
                    border: "1px solid #003E6B",
                    boxSizing: "border-box",
                    width: "100%",
                    height: "19px"
                  }}>
                  </div>
                </div>
                <div
                  style={{ height: (height + 40) + "px", background: "#99DFF9" }}
                  onDrop={dropOption}
                >
                  {
                    (lane === "DNA Ladder")?(
                      getLadder(ticks)
                    ):(
                      <ul style={{ position: "relative", padding: "20px 0" }}>
                        {lanes[lane].map((offset, bandIndex) => {
                          return offset !== null ? (
                            <GelItem
                              type={lane}
                              id={bandIndex + 1}
                              setOffset={setOffset}
                              offset={offset}
                              currentObj={currentObj}
                              setCurrentObj={setCurrentObj}
                            />
                          ) : null;
                        })}
                      </ul>
                    )
                  }
                </div>
              </li>
            ))}
          </ul>
          <div
            style={{ display: "flex", flexDirection: "row" }}
            onDrop={dropTrash}
          >
            <div
              style={{
                width: "80px",
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <img
                style={{ margin: "0 8px 0 0" }}
                src={IconTrash}
                alt="Trash"
              />
            </div>
            <div
              style={{
                background: "#002F50",
                minHeight: "54px",
                flex: "1",
                padding: "0 0 8px 0",
              }}
            >
              <ul
                style={{
                  display: "flex",
                  flexDirection: "row",
                  margin: "0 2px",
                }}
              >
                {Object.keys(lanes).map((lane, index) => (
                  <li
                    style={{
                      width:
                        "calc(" +
                        100 / (Object.keys(lanes).length - 2) +
                        "% - " +
                        100 / (Object.keys(lanes).length - 2) +
                        "px)",
                    }}
                  >
                    <div>
                      <ul style={{ position: "relative" }}>
                        {lanes[lane].map((offset, bandIndex) => {
                          return offset === null ? (
                            <TrashItem
                              type={lane}
                              id={bandIndex + 1}
                              currentObj={currentObj}
                              setCurrentObj={setCurrentObj}
                              offset={offset}
                            />
                          ) : null;
                        })}
                      </ul>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div style={{textAlign: "right", marginTop: "16px"}}>
        <Button disabled={submitted} className='submitGel' onClick={(e)=>saveGel(e)}>
          Submit
        </Button>
      </div>
    </div>
  );
}
GelDragDrop.propTypes = {
  type: PropTypes.string,
  content: PropTypes.array,
  dragdrop: PropTypes.object.isRequired,
  heading: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  className: PropTypes.string,
};

GelDragDrop.defaultProps = {
  className: "gelDragDrop",
};
